import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const Body = ({ text }) => text.split(/\n\s*\n/).map((b, i) => {
  const t = b.trim();
  if (t.startsWith("# ")) return <h2 key={i} className="asv-display mt-8 text-2xl font-extrabold">{t.slice(2)}</h2>;
  const lines = t.split("\n");
  const items = lines.filter((l) => l.startsWith("- "));
  if (items.length) {
    const lead = lines.filter((l) => !l.startsWith("- ")).join("\n");
    return <div key={i} className="mt-4">{lead && <p className="whitespace-pre-line leading-relaxed">{lead}</p>}
      <ul className="mt-2 list-disc space-y-1.5 pl-5 leading-relaxed">{items.map((l, n) => <li key={n}>{l.slice(2)}</li>)}</ul></div>;
  }
  return <p key={i} className="mt-4 whitespace-pre-line leading-relaxed">{t}</p>;
});

export default function AsvPage() {
  const { slug } = useParams();
  const [p, setP] = useState(undefined);
  useEffect(() => { setP(undefined); api.get(`/asv/pages/${slug}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [slug]);
  if (p === undefined) return <div className="asv-card mt-10 h-60 animate-pulse" />;
  if (!p) return <div className="py-20 text-center" data-testid="asv-page-missing"><p className="asv-display text-3xl font-extrabold">Page not found</p><Link to="/" className="asv-accent mt-4 inline-block font-bold">Back to home</Link></div>;
  return (
    <article className="mx-auto max-w-3xl pt-10" data-testid="asv-page">
      <h1 className="asv-display text-4xl font-extrabold sm:text-5xl" data-testid="asv-page-title">{p.title}</h1>
      <div className="asv-muted" data-testid="asv-page-body"><Body text={p.body || ""} /></div>
    </article>
  );
}
